import { logError } from '@/composables';
import { showToast } from '@/composables/swal';
import { ApiResponse } from '@/models';
import Axios, { AxiosError, AxiosInstance } from 'axios';

const base_url = import.meta.env.VITE_APP_BASE_URL;

const http: AxiosInstance = Axios.create({
  baseURL: import.meta.env.VITE_APP_BASE_URL,
  headers: {
    'Content-type': 'application/json',
    'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
});

const noTokenRequest: AxiosInstance = Axios.create({
  baseURL: base_url,
  headers: {
    'Content-type': 'application/json',
    'X-Timezone': Intl.DateTimeFormat().resolvedOptions().timeZone,
  },
});

http.interceptors.request.use((request) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }
  return request;
});

http.interceptors.response.use(
  function (response) {
    return response;
  },
  //eslint-disable-next-line
  function (error) {
    if (401 === error.response.status) {
      window.location.href = `${import.meta.env.VITE_VUE2_APP_URL}/login`;
    } else {
      return Promise.reject(error);
    }
  }
);

const handleResponseException = (
  errorResponse: AxiosError<ApiResponse<null>> | TypeError
): void => {
  let message: string | undefined = '';
  if ('isAxiosError' in errorResponse) {
    message = errorResponse.response?.data?.message;
    if (!message) {
      message = errorResponse.response?.statusText;
    }
    showToast(message, 'error');
    logError('Error (Axios): ', message);
  } else {
    message = errorResponse.message;
    showToast(message, 'error');
    logError(`Error (${errorResponse.name}): `, {
      name: errorResponse.name,
      message: errorResponse.message,
      stack: errorResponse.stack,
    });
  }
  logError('Error (Axios): ', message);
};

export { handleResponseException, http, noTokenRequest };
